export type VidyardPlayerInstance = {
  showLightbox: () => void;
  play: () => void;
};

declare global {
  interface Window {
    VidyardV4?: {
      api: {
        renderDOMPlayers: () => void;
        getPlayersByUUID: (uuid: string) => VidyardPlayerInstance[];
        addReadyListener: (
          cb: (uuid: string, player: VidyardPlayerInstance) => void,
          uuid?: string
        ) => void;
      };
    };
  }
}

export function openVidyardLightboxAndPlay(uuid: string): void {
  const api = window.VidyardV4?.api;
  if (!api) return;

  const openAndPlay = (player: VidyardPlayerInstance) => {
    player.showLightbox();
    player.play();
  };

  const players = api.getPlayersByUUID(uuid);
  if (players?.length) {
    openAndPlay(players[0]);
    return;
  }

  api.addReadyListener((_, player) => {
    openAndPlay(player);
  }, uuid);
}
